module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/onboarding-reputación-BR.a3bcd2e1.mp4";